import React, { useState } from 'react';
import {
  AppBar, Box, Button, Container, Divider, Drawer, IconButton,
  List, ListItem, ListItemButton, ListItemText, Stack, Toolbar, Typography
} from '@mui/material';
import { Close, Login as LoginIcon, Menu as MenuIcon } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBusiness } from '../context/BusinessContext';

const PublicHeader = ({ active = 'inicio' }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isCliente } = useAuth();
  const { businessInfo } = useBusiness();
  const businessName = businessInfo?.businessName || process.env.REACT_APP_SITE_NAME || 'Descorcha2';

  const closeAndRun = (action) => {
    setMobileOpen(false);
    action();
  };

  const goHome = (sectionId = 'inicio') => {
    if (location.pathname === '/' || location.pathname === '/sitio') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    navigate(`/sitio#${sectionId}`);
  };

  const goToAccount = () => {
    if (!isAuthenticated) {
      navigate('/login');
    } else {
      navigate(isCliente ? '/catalog-client' : '/dashboard');
    }
  };

  const items = [
    { id: 'inicio', label: 'Inicio', action: () => goHome('inicio') },
    { id: 'cava', label: 'Nuestra cava', action: () => navigate('/cava') },
    { id: 'contacto', label: 'Contacto', action: () => goHome('contacto') }
  ];

  return (
    <>
      <AppBar position="fixed" elevation={0} className="wine-nav">
        <Container maxWidth="xl">
          <Toolbar disableGutters className="wine-toolbar">
            <Box className="wine-brand" onClick={() => goHome('inicio')}>
              <Box component="img" src="/descorcha2-logo.png" alt={businessName} />
              <Box>
                <Typography component="span">{businessName}</Typography>
                <small>WINES &amp; DRINKS</small>
              </Box>
            </Box>

            <Stack direction="row" spacing={0.5} className="wine-desktop-nav">
              {items.map((item) => (
                <Button
                  key={item.id}
                  color="inherit"
                  className={active === item.id ? 'wine-current-link' : ''}
                  onClick={item.action}
                >
                  {item.label}
                </Button>
              ))}
              <Button className="wine-login-button" startIcon={<LoginIcon />} onClick={goToAccount}>
                {isAuthenticated ? 'Ir al panel' : 'Ingresar'}
              </Button>
            </Stack>

            <IconButton
              className="wine-mobile-menu"
              color="inherit"
              onClick={() => setMobileOpen(true)}
              aria-controls="public-mobile-menu"
              aria-expanded={mobileOpen}
              aria-label="Abrir menú"
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        PaperProps={{ className: 'wine-drawer', id: 'public-mobile-menu' }}
      >
        <Box className="wine-drawer-header">
          <Typography variant="h6">{businessName}</Typography>
          <IconButton onClick={() => setMobileOpen(false)}><Close /></IconButton>
        </Box>
        <Divider />
        <List className="wine-drawer-list">
          {items.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                selected={active === item.id}
                onClick={() => closeAndRun(item.action)}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          ))}
          <Divider sx={{ my: 1 }} />
          <ListItem disablePadding>
            <ListItemButton onClick={() => closeAndRun(goToAccount)}>
              <LoginIcon sx={{ mr: 2 }} />
              <ListItemText primary={isAuthenticated ? 'Ir al panel' : 'Ingresar'} />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default PublicHeader;
